import TimelineFullImage from '../../../../timeline/TimelineFullImage/TimelineFullImage';

const Image = require('../../../../../assets/img/timeline/modal/1996-golf.jpg');


const GolfContent = () => {
    return (
        <>
            <TimelineFullImage image={Image} />
            <h4>
                
            </h4>
            <p>
                The national golf event “Chip In” commenced, known today as ‘Tee Off for Breast Cancer Trials’. This annual golf event involves over 300 golf clubs nationally and has raised $2.2M to date. 
            </p>
        </>
    );
}

export default GolfContent;